import React, { lazy, Suspense } from "react";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import LoadingAnimation from "./components/LoadingAnimation/LoadingAnimation";
import ReactDOM from "react-dom/client";
import App from "./App";
import ScrollToTop from "./components/ScrollToTop";
import WhatsAppButton from "./components/WhatsAppButton/WhatsAppButton";
import reportWebVitals from "./reportWebVitals";
import "./index.css";

const Home = lazy(() => import("./pages/Home/Home"));
const About = lazy(() => import("./pages/About/About"));
const Contacts = lazy(() => import("./pages/Contacts/Contacts"));
const Services = lazy(() => import("./pages/Services/Services"));
const AuthenticImageMentoring = lazy(() =>
  import("./pages/Services/AuthenticImageMentoring")
);
const FindYourStyle = lazy(() => import("./pages/Services/FindYourStyle"));
const LookAssembly = lazy(() => import("./pages/Services/LookAssembly"));
const Styling = lazy(() => import("./pages/Services/Styling"));
const ComercialStyling = lazy(() =>
  import("./pages/Services/ComercialStyling")
);
const TravelBagPlanning = lazy(() =>
  import("./pages/Services/TravelBagPlanning")
);
const PersonalColorAnalysis = lazy(() =>
  import("./pages/Services/PersonalColorAnalysis")
);
const GiftVouchers = lazy(() => import("./pages/Services/GiftVouchers"));
const ContentManagement = lazy(() =>
  import("./pages/Services/ContentManagement")
);
const StrategicBrandConsulting = lazy(() =>
  import("./pages/Services/StrategicBrandConsulting")
);
const TermsConditions = lazy(() => import("./pages/legal/terms-conditions"));
const PrivacyPolicy = lazy(() => import("./pages/legal/privacy-policy"));
const LinkTree = lazy(() => import("./pages/link-tree/LinkTree"));

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Suspense fallback={<LoadingAnimation />}>
        <ScrollToTop />
        <Routes>
          <Route
            exact
            path="/"
            element={
              <App>
                <Home />
              </App>
            }
          />
          <Route
            exact
            path="/sobre"
            element={
              <App>
                <About />
              </App>
            }
          />
          <Route
            exact
            path="/contactos"
            element={
              <App>
                <Contacts />
              </App>
            }
          />
          <Route
            exact
            path="/servicos"
            element={
              <App>
                <Services />
              </App>
            }
          />
          <Route
            exact
            path="/servicos/mentoria-imagem-autentica"
            element={
              <App>
                <AuthenticImageMentoring />
              </App>
            }
          />
          <Route
            exact
            path="/servicos/consultoria-estilo-pessoal"
            element={
              <App>
                <FindYourStyle />
              </App>
            }
          />
          <Route
            exact
            path="/servicos/montagem-looks"
            element={
              <App>
                <LookAssembly />
              </App>
            }
          />
          <Route
            exact
            path="/servicos/styling-eventos"
            element={
              <App>
                <Styling />
              </App>
            }
          />
          <Route
            exact
            path="/servicos/styling-comercial"
            element={
              <App>
                <ComercialStyling />
              </App>
            }
          />
          <Route
            exact
            path="/servicos/planeamento-mala-viagem"
            element={
              <App>
                <TravelBagPlanning />
              </App>
            }
          />
          <Route
            exact
            path="/servicos/coloracao-pessoal"
            element={
              <App>
                <PersonalColorAnalysis />
              </App>
            }
          />
          {/* <Route
            exact
            path="/servicos/workshop-pro"
            element={
              <App>
                <WorkshopPro />
              </App>
            }
          /> */}
          {/* <Route
            exact
            path="/mentoria-imagem-topo"
            element={<MentoriaImagemTopo />}
          /> */}
          <Route
            exact
            path="/servicos/gift-vouchers"
            element={
              <App>
                <GiftVouchers />
              </App>
            }
          />
          <Route
            exact
            path="/servicos/gestao-conteudos"
            element={
              <App>
                <ContentManagement />
              </App>
            }
          />
          <Route
            exact
            path="/servicos/consultoria-marca-estrategica"
            element={
              <App>
                <StrategicBrandConsulting />
              </App>
            }
          />

          <Route
            exact
            path="/legal/termos-condicoes"
            element={
              <App>
                <TermsConditions />
              </App>
            }
          />
          <Route
            exact
            path="/legal/politica-privacidade"
            element={
              <App>
                <PrivacyPolicy />
              </App>
            }
          />
          <Route exact path="/links-uteis" element={<LinkTree />} />
          <Route
            path="*"
            element={
              <App>
                <Home />
              </App>
            }
          />
        </Routes>
      </Suspense>
      <WhatsAppButton />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
